import { render, staticRenderFns } from "./Property.vue?vue&type=template&id=6f27e19a"
import script from "./Property.vue?vue&type=script&lang=js"
export * from "./Property.vue?vue&type=script&lang=js"
import style0 from "./Property.vue?vue&type=style&index=0&id=6f27e19a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports